import React from 'react';
export function Footer() {
  return <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto" data-id="element-226">
      <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-227">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-228">
          <div className="flex items-center gap-2" data-id="element-229">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-8 w-auto object-contain" data-id="element-230" />
            <span className="text-sm font-semibold text-gray-900 dark:text-white" data-id="element-231">
              
            </span>
          </div>

          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-232">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>

          <div className="flex gap-4 text-sm text-gray-600 dark:text-gray-400" data-id="element-233">
            <a href="#" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-234">
              Términos
            </a>
            <a href="#" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-235">
              Privacidad
            </a>
          
          </div>
        </div>
      </div>
    </footer>;
}